export default "__VITE_PUBLIC_ASSET__150d93e4__"